import React from "react";
import { Button } from "../Button/Button";

import styles from "./ErrorPage.module.css";

const ErrorPage = ({ errorMessage }) => {
  return (
    <div className={styles.errorPageContainer}>
      <div className={styles.errorMessage}>Oops! Something went wrong.</div>
      <div className={styles.errorDetails}>{errorMessage}</div>
      <div className={styles.buttonsWrapper}>
        <Button
          size="lg"
          variant="primary"
          label="Refresh Page"
          onClick={() => window.location.reload()}
        />
        <Button
          size="lg"
          variant="primary"
          label="Back To Home"
          onClick={() => (window.location.href = "/")}
        />
      </div>
    </div>
  );
};

export default ErrorPage;
